import { BadgeM } from "@common/components/badge/BadgeM"
import TextM from "@common/components/text/TextM"
import { HeaderContainerM } from "@common/header/HeaderContainerM"
import useLiveKitEventSender from "@common/hooks/livekit/useLiveKitEventSender"
import CommonChat, { transformMessage } from "@common/messenger/CommonChat"
import { avatarColors } from "@data/constants/studentsConstants"
import { apiIdle, apiRequest } from "@data/redux/actions/api"
import { changeUnreadMessageInLiveCount } from "@data/redux/actions/broadcast"
import { setIsLiveModeEnabled } from "@data/redux/actions/liveMode"
import { messengerService } from "@data/services/messengerService"
import { hasRole } from "@data/utility/ability"
import { useNavigation } from "@react-navigation/native"
import React, { useEffect, useRef, useState } from "react"
import { ScrollView, TouchableOpacity, View } from "react-native"
import { GiftedChat } from "react-native-gifted-chat"
import { IconButton } from "react-native-paper"
import getContrastingColor from "react-native-paper/src/utils/getContrastingColor"
import { connect } from "react-redux"
import { resetLiveMessagesCount } from "../../data/redux/actions/liveMode"
import LiveAvatarM from "../../tutor/students/LiveAvatarM"
import { theme } from "../theme/theme"

export const AvatarWithInfos = ({ user }) => (
    <View
        style={{
            flexDirection: "row",
            alignItems: "center",
        }}
    >
        {user?.id !== 0 && <LiveAvatarM user={user} size={40} />}
        <View
            style={{
                marginLeft: 5,
            }}
        >
            <TextM fontSize={14} fontWeight={"Medium"}>
                {user?.display_name}
            </TextM>
            {user?.profile?.class && (
                <TextM fontSize={10}>{user?.profile?.class}</TextM>
            )}
        </View>
    </View>
)

export function hasValueGreaterThanZero(obj) {
    for (let key in obj) {
        if (
            obj.hasOwnProperty(key) &&
            typeof obj[key] === "number" &&
            obj[key] > 0
        ) {
            return true // Found a value greater than 0
        }
    }
    return false // No value greater than 0 found
}

const LiveChat = (props) => {
    const { nav, onExit, route } = props
    const navigation = nav ? nav : useNavigation()
    const userId = props.route?.params?.userId ?? props.userId ?? null
    const [messages, setMessages] = useState([])
    const liveSession = props.currentLiveSession
    const groupChatUser = {
        display_name: "Tous",
        thread_id: liveSession?.thread_id,
        id: 0,
    }
    const chatMembers = hasRole(props.user, "student")
        ? liveSession?.users?.filter((x) => x?.is_tutor) ?? []
        : liveSession?.users?.filter((user) => !user.is_tutor) ?? []
    const user =
        userId?.toString() === "0"
            ? groupChatUser
            : chatMembers?.find((x) => x.id?.toString() === userId?.toString())
    const [cUser, setCurrentUser] = useState(user ?? groupChatUser)
    const currentUser =
        chatMembers?.find((x) => x.id === cUser?.id) ?? groupChatUser
    const [threadId, setThreadId] = useState(
        liveSession?.thread_ids[currentUser?.id] ?? liveSession?.thread_id
    )

    const { sendLiveKitData: triggerTyping } = useLiveKitEventSender()
    const { sendLiveKitData: triggerSendMessage } = useLiveKitEventSender()

    const goToMyTutor = () => {
        const tutor = liveSession?.users?.find((x) => x?.is_tutor)
        setCurrentUser(tutor)
        setThreadId(liveSession?.thread_ids?.[tutor.id])
    }

    const unreadTotalMessagesCount =
        hasValueGreaterThanZero(liveSession?.unread_private_messages_count) ||
        liveSession?.unread_messages_count > 0

    const ChatAvatar = ({ user }) => {
        const unreadMessagesCount =
            user?.id !== 0
                ? props.currentLiveSession?.unread_private_messages_count?.[
                      user?.id
                  ]
                : props.currentLiveSession?.unread_messages_count
        return (
            <TouchableOpacity
                style={{
                    alignItems: "center",
                    marginHorizontal: 10,
                    paddingHorizontal: 15,
                    justifyContent: "center",
                    backgroundColor:
                        user?.id === currentUser?.id
                            ? theme.colors.primaryLighter
                            : null,
                }}
                onPress={() => {
                    setCurrentUser(user)
                    setThreadId(
                        liveSession?.thread_ids?.[user.id] ??
                            liveSession?.thread_id
                    )
                }}
            >
                <View style={{ flexDirection: "row", alignItems: "center" }}>
                    {user?.display_name === "Groupe" ? (
                        <View
                            style={{
                                width: 40,
                                height: 40,
                                borderRadius: 20,
                                alignItems: "center",
                                justifyContent: "center",
                                backgroundColor:
                                    avatarColors[
                                        user?.id
                                            ? user?.id % avatarColors.length
                                            : 0
                                    ],
                            }}
                        >
                            <TextM
                                fontSize={8}
                                color={getContrastingColor(
                                    avatarColors[
                                        user?.id
                                            ? user?.id % avatarColors.length
                                            : 0
                                    ],
                                    theme.colors.white,
                                    "rgba(0, 0, 0, .54)"
                                )}
                            >
                                {user?.display_name}
                            </TextM>
                        </View>
                    ) : (
                        <LiveAvatarM
                            user={user}
                            size={40}
                            style={{ marginRight: 0 }}
                        />
                    )}
                    {user?.id === currentUser?.id && (
                        <TextM
                            color={theme.colors.primary}
                            style={{ marginLeft: 10, maxWidth: 100 }}
                            fontSize={14}
                            fontWeight={"Bold"}
                        >
                            {currentUser?.display_name}
                        </TextM>
                    )}
                </View>
                {unreadMessagesCount > 0 && (
                    <BadgeM
                        count={
                            props.currentLiveSession
                                .unread_private_messages_count?.[user.id] ??
                            props.currentLiveSession?.unread_messages_count
                        }
                        size={16}
                        style={{
                            backgroundColor: theme.colors.error,
                            color: theme.colors.white,
                            position: "absolute",
                            top: 10,
                            right: 10,
                        }}
                    />
                )}
            </TouchableOpacity>
        )
    }

    useEffect(() => {
        let item = props.user?.new_message?.user
            ? props.user?.new_message
            : transformMessage(props.user?.new_message)

        setMessages((old) => {
            if (old?.find((msg) => msg.threadId === item?.threadId)) {
                return GiftedChat.append(old, [item])
            }

            return old
        })
    }, [props.user?.new_message])

    const prevThreadId = useRef()

    useEffect(() => {
        if (prevThreadId.current === undefined) return

        if (
            props.user.messages[threadId] &&
            threadId !== prevThreadId.current
        ) {
            setMessages(
                props.user?.messages[threadId]
                    ?.map(transformMessage)
                    .filter((msg) => msg._id)
            )
            props.apiRequest(messengerService.getMarkRead, {
                threadId: threadId,
            })
            prevThreadId.current = threadId
        }
    }, [props.user.messages, threadId])

    // List with currentUser as first (if currentUser?.id === 0, group is first)
    const orderedUsersList = [
        currentUser,
        ...[groupChatUser, ...chatMembers].filter(
            (user) => user?.id !== currentUser?.id
        ),
    ]

    return (
        <View
            style={{
                flex: 1,
                backgroundColor: theme.colors.whiteAlmost,
                paddingTop: 0,
                width: "100%",
                alignSelf: "center",
                alignItems: "center",
            }}
        >
            <HeaderContainerM
                style={{
                    justifyContent: "flex-end",
                    alignItems: "center",
                    width: "100%",
                }}
                forceTopInset={!props.userId?.toString()}
            >
                <ScrollView
                    horizontal={true}
                    style={{ flex: 1, height: 60 }}
                    contentContainerStyle={{
                        flexDirection: "row",
                        paddingLeft: 50,
                    }}
                >
                    {orderedUsersList.map((user, index) => {
                        return <ChatAvatar user={user} key={index} />
                    })}
                </ScrollView>

                <IconButton
                    icon={"times"}
                    iconColor={theme.colors.primary}
                    containerColor={theme.colors.transparent}
                    size={32}
                    style={{
                        position: "absolute",
                        left: 0,
                        backgroundColor: theme.colors.white,
                    }}
                    onPress={() => {
                        if (!onExit) {
                            if (navigation.canGoBack()) navigation.goBack()
                            else navigation.replace("menu")
                        } else {
                            onExit()
                        }
                    }}
                />
            </HeaderContainerM>
            <CommonChat
                setMessages={setMessages}
                messages={messages}
                triggerTyping={triggerTyping}
                triggerSendMessage={triggerSendMessage}
                threadId={threadId}
                liveChat
                groupChat
                participants={liveSession?.users}
                currentUser={currentUser}
                unreadMessagesCount={unreadTotalMessagesCount}
                goToMyTutor={goToMyTutor}
                onExit={onExit}
                nav={navigation}
                route={route}
                noBottomInset={!!props.userId?.toString()}
            />
        </View>
    )
}

const mapStateToProps = (state) => {
    return {
        getMessagesRequest: state.api.getMessages?.request,
        getMessagesSuccess: state.api.getMessages?.success,
        getMessagesError: state.api.getMessages?.error,

        getPageMessagesRequest: state.api.getPageMessages?.request,
        getPageMessagesSuccess: state.api.getPageMessages?.success,
        getPageMessagesError: state.api.getPageMessages?.error,

        getMarkReadRequest: state.api.getMarkRead?.request,
        getMarkReadSuccess: state.api.getMarkRead?.success,
        getMarkReadError: state.api.getMarkRead?.error,

        postMessagesRequest: state.api.postMessages?.request,
        postMessagesSuccess: state.api.postMessages?.success,
        postMessagesError: state.api.postMessages?.error,

        user: state.data.currentUser?.object,
        token: state.data.session?.object?.token,

        liveSessionId: state.liveMode?.liveSessionId,
        liveSessions: state.data.currentUser?.object?.live_sessions,
        currentLiveSession: state.data.currentUser?.object?.live_sessions?.find(
            (x) => x?.id === state.liveMode?.liveSessionId
        ),

        participants: state.liveMode?.liveParticipants,
        tutors: state.liveMode?.liveTutors,
    }
}

const mapDispatchToProps = {
    apiRequest,
    apiIdle,
    setIsLiveModeEnabled,
    resetLiveMessagesCount,
    changeUnreadMessageInLiveCount,
}
export default connect(mapStateToProps, mapDispatchToProps)(LiveChat)
